// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AuthProvider, { useAuth } from "./context/AuthContext";
import MessagesPage from "./pages/MessagesPage";
import CalculatorPage from "./pages/CalculatorPage";

import PrivateRoute from './components/PrivateRoute';
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import MonCompte from "./pages/MonCompte";
import EpsonPrintPage from './pages/EpsonPrintPage';
import BookingWrapper from './pages/BookingWrapper';
import MyBookings from './pages/MyBookings';
import ReferFriend from "./pages/ReferFriend";
import Statistiques from "./pages/Statistiques";
import PayerEnLigne from "./pages/PayerEnLigne";
import Feedback from "./pages/Feedback";
import PaymentStatusPage from "./pages/payment-status";
import BuvetteMenu from "./pages/BuvetteMenu";
import LoyaltyClaimPage from "./pages/LoyaltyClaimPage";
import NFCPage from "./pages/incidents";
import LateAccessRequest from "./pages/LateAccessRequest";
import PowerBank from "./pages/PowerBank";
import MyTablePage from "./pages/MyTablePage";
import PomodoroPage from "./pages/PomodoroPage";
import EquipmentPage from "./pages/EquipmentPage";
import LibraryPage from "./pages/LibraryPage";
import BoothPage from "./pages/BoothPage";
import CasierPage from "./pages/CasierPage";
import LostFoundPage from "./pages/LostFoundPage";
import MemoriesPage from "./pages/MemoriesPage";
import HeadphonesPage from "./pages/HeadphonesPage";
import LateAccessTutorial from "./pages/LateAccessTutorial";
import GenericEquipmentPage from "./pages/GenericEquipmentPage";
import CafePage from "./pages/CafePage";
function AppRoutes() {
  const { user } = useAuth(); // ✅ FIXED

  return (
<Routes>
  <Route path="/login" element={<LoginPage />} />

  {/* ── Core — no restriction ── */}
  <Route path="/"               element={<PrivateRoute><HomePage /></PrivateRoute>} />
  <Route path="/home"           element={<PrivateRoute><HomePage /></PrivateRoute>} />
  <Route path="/mon-compte"     element={<PrivateRoute><MonCompte /></PrivateRoute>} />
  <Route path="/payment"        element={<PrivateRoute><PayerEnLigne /></PrivateRoute>} />
  <Route path="/payment-status" element={<PrivateRoute><PaymentStatusPage /></PrivateRoute>} />
  <Route path="/table"          element={<PrivateRoute><MyTablePage /></PrivateRoute>} />
  <Route path="/statistiques"   element={<PrivateRoute><Statistiques /></PrivateRoute>} />
  <Route path="/refer"          element={<PrivateRoute><ReferFriend /></PrivateRoute>} />
  <Route path="/loyalty"        element={<PrivateRoute><LoyaltyClaimPage /></PrivateRoute>} />
  <Route path="/feedback"       element={<PrivateRoute><Feedback /></PrivateRoute>} />
  <Route path="/my-bookings"    element={<PrivateRoute><MyBookings /></PrivateRoute>} />
<Route path="/pomodoro" element={<PrivateRoute><PomodoroPage /></PrivateRoute>} />

  {/* ── Feature-gated ── */}
  <Route path="/booking"    element={<PrivateRoute feature="booking">   <BookingWrapper />    </PrivateRoute>} />
  <Route path="/print"      element={<PrivateRoute feature="print">     <EpsonPrintPage />    </PrivateRoute>} />
  <Route path="/buvette"    element={<PrivateRoute feature="buvette">   <BuvetteMenu />       </PrivateRoute>} />
  <Route path="/powerbank"  element={<PrivateRoute feature="powerbank"> <PowerBank />         </PrivateRoute>} />
  <Route path="/latenight"  element={<PrivateRoute feature="latenight"> <LateAccessRequest /> </PrivateRoute>} />
  <Route path="/booth"      element={<PrivateRoute feature="booth">     <BoothPage />         </PrivateRoute>} />
  <Route path="/casier"     element={<PrivateRoute feature="casier">    <CasierPage />        </PrivateRoute>} />
  <Route path="/library"    element={<PrivateRoute feature="library">   <LibraryPage />       </PrivateRoute>} />
  <Route path="/equipment"  element={<PrivateRoute feature="equipment"> <EquipmentPage />     </PrivateRoute>} />
  <Route path="/messages"   element={<PrivateRoute feature="messages">  <MessagesPage />      </PrivateRoute>} />
  <Route path="/lostfound"   element={<PrivateRoute feature="lostfound">  <LostFoundPage />      </PrivateRoute>} />

  <Route path="/headphones"   element={<PrivateRoute feature="headphones">  <HeadphonesPage />      </PrivateRoute>} />
     <Route path="/cafe" element={<PrivateRoute feature="Café"><CafePage /></PrivateRoute>} />
<Route path="/latenight-tutorial" element={<PrivateRoute><LateAccessTutorial /></PrivateRoute>} />
<Route path="/equipment/:catId" element={<PrivateRoute><GenericEquipmentPage /></PrivateRoute>} />
  <Route path="/incidents"  element={<PrivateRoute feature="incidents"> <NFCPage />           </PrivateRoute>} />
  <Route path="/calculators" element={<PrivateRoute feature="calculators"><CalculatorPage /></PrivateRoute>} />

</Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
